module.exports = "/_next/static/images/advance-loader-c416da9d31b173006958187b7badd37f.gif";